module.exports = __webpack_public_path__ + "img/master-img.562471ec.png";